<!-- main fuse app layout -->
<fuse-app></fuse-app>

<!-- Portal Content -->
<app-toolbar-content></app-toolbar-content>